
/**
 * Only works for number field. Does not work for text field
 */
app .directive('numberFieldDecimal', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      decimals: '=',
      applyDecimals: '='
    },
    link: function(scope, element, attrs, modelCtrl) {
      // Check if the element is an input of type "number". This directive only works on number field
      if (element[0].nodeName.toLowerCase() !== 'input' || attrs.type !== 'number') {
        throw new Error('numberFieldDecimal directive can only be used with <input type="number">');
      }
      element.bind('keypress', function(event) {
        // do not allow decimals if applyDecimals is false and the key pressed is a decimal
        if (!scope.applyDecimals && (event.charCode === 46)) {
          event.preventDefault();
        }
      });
      modelCtrl.$parsers.push(function(inputValue) {
        if (inputValue == undefined) return '';
        if (!scope.applyDecimals) {
          // remove decimals if present
          inputValue = Math.floor(inputValue);
          return inputValue;
        }
        let transformedInput = parseFloat(inputValue).toFixed(scope.decimals);
        if (transformedInput != inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    }
  };
});
